(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ugc-grid"] && !Shopify.designMode) return;
  try {
    
(function() {
  function startUGCVideos() {
    document.querySelectorAll('.ugc__media').forEach(function(v) {
      v.removeAttribute('poster');
      v.muted = true;
      v.loop = true;
      v.playsInline = true;
      v.load();
      v.addEventListener('canplay', function() {
        v.play().catch(function(){});
      }, { once: true });
      setTimeout(function() {
        if (v.paused) v.play().catch(function(){});
      }, 1000);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { setTimeout(startUGCVideos, 500); });
  } else {
    setTimeout(startUGCVideos, 500);
  }
  window.addEventListener('load', function() { setTimeout(startUGCVideos, 300); });
})();

  } catch(e) { console.error(e); }
})();
})();
